
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bimbel",
      function () {
        return require("private-next-pages/bimbel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bimbel"])
      });
    }
  